import { GoogleMap, InfoWindow, Marker, useLoadScript } from "@react-google-maps/api";
import { useMemo } from "react";

export default function Maps() {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyCU-hAEN284trRtuD8-y41Jjzj1J4Lz-KU",
  });

  if (!isLoaded) return <div>Loading...</div>;
  return <Map />;
}

function Map() {
  const center = useMemo(() => ({ lat: 57.721487196609054, lng: 12.941246932943946 }), []);
  const place = 
    {
       name: "Khói Restaurant",
       text: "Hello",
       position: {lat: 57.721487196609054,lng: 12.941246932943946}
    }
  
  return (
    <>
    <GoogleMap zoom={18} center={center} mapContainerClassName="map-container">
        <Marker
            key={`marker-${place.name}`}
            title={place.name}
            name={place.name}
            position={place.position}
        >
        </Marker>
    </GoogleMap>
    </>
  );
}